import type { CSSProperties } from 'react';
import Lottie from 'react-lottie';

type LottieImageProps = {
	animationData: any;
	height?: number;
	width?: number;
	style?: CSSProperties;
	className?: string;
};

const LottieImage = ({ animationData, height, width, style = {}, className = '' }: LottieImageProps) => {
	return (
		<div
			className={className}
			style={{
				margin: 0,
				display: 'inline-flex',
				overflow: 'hidden',
				lineHeight: 0,
				width,
				height,
				...style,
			}}
		>
			<Lottie
				options={{
					loop: true,
					autoplay: true,
					animationData,
					rendererSettings: {
						preserveAspectRatio: 'xMidYMid meet',
					},
				}}
				height={height}
				width={width}
			/>
		</div>
	);
};

LottieImage.defaultProps = {
	height: undefined,
	width: undefined,
	style: {},
	className: '',
};

export default LottieImage;
